import React, { useContext, useEffect, useRef, useState } from 'react';
import { useAuth0 } from "@auth0/auth0-react";

import {
    Box,
    List,
    useTheme,
    useMediaQuery,
    Typography
} from '@mui/material';

import { useGridApiRef } from '@mui/x-data-grid-pro';

import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';

import PermissionGuard from '../contexts/PermissionContext';
import ProjectContext from '../contexts/ProjectContext';

import ItemList from '../components/menuitem/ItemList';

import ControlBar from '../components/structure/ControlBar';
import ControlButton from '../components/structure/ControlButton';

import AleConfig from '../components/settings/AleConfig';
import PdfConfig from '../components/settings/PdfConfig';
import SyncConfig from '../components/settings/SyncConfig';
import EXRInjectionConfig from '../components/settings/EXRInjectionConfig';
import VerticalDivider from '../components/divider/VerticalDivider';
import LaptopIcon from '@mui/icons-material/Laptop';

import CreateConfigPopover from '../components/popover/CreateConfigPopover';
import MenuPopover from '../components/popover/MenuPopover';

import { Tab, Tabs } from '@mui/material';
import { itemIcons } from '../components/SideItems/SideItems';
import ControlDivider from '../components/structure/ControlDivider';
import useEnhancedEffect from '@mui/material/utils/useEnhancedEffect';
import {useFetch} from '../components/auth/useFetch';

// In milliseconds
let minimumLoadingAnimationDuration = 2000;


export default function DeliverableConfigView(props) {
    
    const viewname = 'Deliverable Configuration'

    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.down('md'))


    const { isAuthenticated } = useAuth0();
    const projectContext = useContext(ProjectContext);

    const [anchorEl, setAnchorEl] = useState(null)
    const [menuContent, setMenuContent] = useState(<></>)

    const [deliverables, setDeliverables] = useState([])
    const [currentDeliverable, setCurrentDeliverable] = useState({})
    const [deliverableConfig, setDeliverableConfig] = useState({})
    const [savedUpdate, setSavedUpdate] = useState(0)

    const portalRef = useRef(null)
    const gridRef = useGridApiRef();
    const fetchWithAuth = useFetch()


    useEffect(() => {      
        isAuthenticated && (async () => {
        try {
            getAllConfigs()
        } catch (e) {
            console.error(e);
        }
        })();
    }, [isAuthenticated])


    const openMenu = (e) => {
        setAnchorEl(e.currentTarget)
    }

    const closeMenu = (e) => {
        setAnchorEl(null)
    }

    const openCreateConfigMenu = (e) => {

        openMenu(e)
        setMenuContent(
            <CreateConfigPopover
                deliverables={deliverables}
                setDeliverables={setDeliverables}
                setCurrentDeliverable={setCurrentDeliverable}
                submitConfig={submitConfig}
            />
        )
    }

    const undoConfig = (undo) => {
        let url = `${process.env.REACT_APP_BACKEND_URL}/konsol/dbconfig/?config_name=${currentDeliverable.name}&config_type=${currentDeliverable.type}&function=${undo}`
        fetchWithAuth(url, {
            method: 'PATCH',
            headers:{
                'X-Project-ID': projectContext?.project_db
            },
        }).then(setSavedUpdate(savedUpdate + 1))
        .catch(e => {
            console.error(e);
        })
    }

    async function deleteConfig() {
        let url = `${process.env.REACT_APP_BACKEND_URL}/konsol/dbconfig/?config_name=${currentDeliverable.name}&config_type=${currentDeliverable.type}`
        try{
        let request = await fetchWithAuth(url, {
            method: 'DELETE',
            headers:{
                'X-Project-ID': projectContext?.project_db
            },
        })
        if (request.status == 204){
            getAllConfigs()
        }
        } catch(e) {
            console.error(e);
        }
    }

    async function submitConfig(body, templateName){
        let url = `${process.env.REACT_APP_BACKEND_URL}/konsol/dbconfig/?config_name=${body.deliverable_name}&config_type=${body.deliverable_type}`
        if(templateName){
            url = `${url}&template_name=${templateName}`
        }
        try{
            let request = await fetchWithAuth(url, {
                method: 'POST',
                body: JSON.stringify(body),
                headers:{
                    'X-Project-ID': projectContext?.project_db,
                    'Content-Type': 'application/json'
                },
            })
            if (request.status == 201){
                getAllConfigs()
            }
        } catch(e) {
            console.error(e);
        }
    }

    async function getAllConfigs(){
        const deliverablesUrl = `${process.env.REACT_APP_BACKEND_URL}/konsol/exportale`
        try{
            let request = await fetchWithAuth(deliverablesUrl, {
                headers: {
                    'X-Project-ID': projectContext?.project_db
                },
            })
            let response = await request.json()
            let data = await response

            setDeliverables(
                data.filter((item) => {
                    return item.type === 'ALE' || item.type === 'CSV' || item.type === 'PDF' || item.type === 'Sync' || item.type === 'Injection'
                })
            )
        } catch(e) {
            console.error(e);
        }
    }


// let request = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/user/`,
// fetchDetails
// )
// let response = await request.json()
// let idCounter = 0;
// let data = await response;

    return (
        <React.Fragment>
            {
                // If tablet or smaller, show page unavailable
                // else show page
                isSm
                ?
                <Box
                    width={'100%'}
                    height={'100%'}
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                >
                    <LaptopIcon
                        sx={{
                            color: "rgba(128,128,128,0.4)",
                            fontSize: 100
                        }}
                    />
                    <Typography color={'rgba(128,128,128,1)'} component="span" variant="h7" align="left" gutterBottom>
                        Feature available on desktop/laptop
                    </Typography>
                </Box>
                :
                <Box 
                    display="flex" 
                    flexDirection="column" 
                    height='100%'
                    width='100%'
                >
                    {/* <Box id='deliverable-config-menubar'/> */}
                    <ControlBar>
                        <Tabs
                            value={viewname}
                            indicatorColor="secondary"
                            variant="scrollable"
                            scrollButtons="auto">
                            <Tab
                                label={
                                    <Box display="flex" alignItems="center">
                                        {itemIcons[viewname]}
                                        <Box ml={1}>{viewname}</Box>
                                    </Box>
                                }
                                style={{ textTransform: 'none', fontWeight: 'bold', color: 'white' }} />
                        </Tabs>
                        <ControlDivider />
                        <PermissionGuard permission={['update:deliverables']}>
                        <ControlButton
                            title='Create Config'
                            clicked={openCreateConfigMenu}
                        >
                            <CreateNewFolderIcon style={{fill: 'white'}} />
                        </ControlButton>
                        <VerticalDivider />
                        </PermissionGuard>
                        <Box ref={portalRef} 
                            sx={{
                                display: 'flex'
                            }}
                        />
                    </ControlBar>
                    <Box
                        display={'flex'}
                        flexDirection={'row'}
                        height='calc(100% - 47px)'
                        width='100%'
                    >
                        <Box
                            height='100%'
                            minWidth='300px'
                            maxWidth='300px'
                            bgcolor='rgba(0,0,0,0.9)'
                            overflow={'auto'}
                        >
                            <List 
                                sx={{
                                    color: 'white',
                                    width: '100%'
                                }}
                            >
                            {deliverables.map((exp, index) => {
                                return (
                                    <ItemList
                                        key={index}
                                        title={exp.name} 
                                        label={exp.type} 
                                        onItemClick={() => {
                                            setCurrentDeliverable(exp)
                                        }}
                                    />
                                )
                            })}
                            </List>
                        </Box>
                        {/* 
                            Width calculation:
                            100%
                            - 300px(File selection panel width)
                            - 4px(Base window border 2px left and right)
                            - 1px (0.5 mx margin left and right)
                        */}
                        <Box
                            mx={0.5}
                            height={'100%'}
                            width={'calc(100% - 300px - 4px - 1px)'}
                        >

                            <Box
                                display='flex'
                                flexDirection={'row'} 
                                width='100%'
                                height='100%'
                                bgcolor='rgba(0,0,0,0.9)'
                            >
                                <AleConfig
                                    deleteConfig={deleteConfig}
                                    deliverable={currentDeliverable}
                                    deliverableConfig={deliverableConfig}
                                    exportType='ALE'
                                    menuRef={portalRef}
                                    metadataRef={gridRef}
                                    openMenu={openMenu}
                                    setDeliverableConfig={setDeliverableConfig}
                                    setMenuContent={setMenuContent}
                                    submitConfig={submitConfig}
                                    undoConfig={undoConfig}
                                    savedUpdate={savedUpdate}
                                />
                                <PdfConfig
                                    deleteConfig={deleteConfig}
                                    deliverable={currentDeliverable}
                                    deliverableConfig={deliverableConfig}
                                    exportType='PDF'
                                    menuRef={portalRef}
                                    metadataRef={gridRef}
                                    openMenu={openMenu}
                                    setDeliverableConfig={setDeliverableConfig}
                                    setMenuContent={setMenuContent}
                                    submitConfig={submitConfig}
                                    undoConfig={undoConfig}
                                    savedUpdate={savedUpdate}
                                />
                                <SyncConfig
                                    deleteConfig={deleteConfig}
                                    deliverable={currentDeliverable}
                                    deliverableConfig={deliverableConfig}
                                    exportType='Sync'
                                    menuRef={portalRef}
                                    metadataRef={gridRef}
                                    openMenu={openMenu}
                                    setDeliverableConfig={setDeliverableConfig}
                                    setMenuContent={setMenuContent}
                                    submitConfig={submitConfig}
                                    undoConfig={undoConfig}
                                    savedUpdate={savedUpdate}
                                />
                                <EXRInjectionConfig
                                    deleteConfig={deleteConfig}
                                    deliverable={currentDeliverable}
                                    deliverableConfig={deliverableConfig}
                                    exportType='Injection'
                                    menuRef={portalRef}
                                    metadataRef={gridRef}
                                    openMenu={openMenu}
                                    setDeliverableConfig={setDeliverableConfig}
                                    setMenuContent={setMenuContent}
                                    submitConfig={submitConfig}
                                    undoConfig={undoConfig}
                                    savedUpdate={savedUpdate}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            }
            <MenuPopover 
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                handleClose={closeMenu}
                content={menuContent}
            />
        </React.Fragment>
    )
}